import { DETAILS_ANALYTICS_METRICS_ORDER } from '../../../config/constants';
import { useLocales } from '../../../locales';

const TopAnalyticsCard = ({ data }) => {
  const { translate: t } = useLocales();
  return (
    <div className="card shadow">
      <div className="card-body">
        <div className="row">
          {Object.keys(data)
            .sort((a, b) => {
              const indexA = DETAILS_ANALYTICS_METRICS_ORDER.indexOf(a);
              const indexB = DETAILS_ANALYTICS_METRICS_ORDER.indexOf(b);
              return indexA - indexB;
            })
            .map((key) => (
              <div key={key} className="col text-center">
                <div>
                  <h1 className="fs-3x">
                    {!data[key] && data[key] !== 0
                      ? '-'
                      : Intl.NumberFormat('en-US', {
                          notation: 'compact',
                          compactDisplay: 'short'
                        }).format(data[key])}
                  </h1>
                  <p className="text-muted fs-4">{t(key)}</p>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default TopAnalyticsCard;
